import { RolloutStage } from "./RolloutStage";
/**
 * Known Entra client app ids (authorization)
 */ export var ClientAppId = /*#__PURE__*/ function(ClientAppId) {
    ClientAppId["PlannerMobile"] = "66375f6b-983f-4c2c-9701-d680650f588f";
    ClientAppId["PlannerWeb"] = "09abbdfd-ed23-44ee-a2d9-a627aa1c90f3";
    ClientAppId["PlannerService"] = "09abbdfd-ed23-44ee-a2d9-a627aa1c90f3";
    ClientAppId["MSTeamsWeb"] = "5e3ce6c0-2b1f-4285-8d4b-75ee78787346";
    ClientAppId["MSTeamsDesktop"] = "1fec8e78-bce4-4aaf-ab1b-5451cc387264";
    /** The "Microsoft Teams Retail Service" client Entra app used to invoke the on-behalf-of mechanism to get access tokens in legacy Teams Tasks app and initially in Teams Uno app */ ClientAppId["MicrosoftTeamsRetailService"] = "75efb5bc-18a1-4e7b-8a66-2ad2503d79c6";
    /** The "Microsoft Planner Client" client Entra app used in Planner/Uno Teams app, Planner/Uno metaOS app, web standalone etc. moving forward */ ClientAppId["MicrosoftPlannerClient"] = "75f31797-37c9-498e-8dc9-53c16a36afca";
    ClientAppId["TrouterPlannerIntegration"] = "21f32f81-5ab1-4b75-833d-9fa211500fd9";
    ClientAppId["Odsp"] = "00000003-0000-0ff1-ce00-000000000000";
    ClientAppId["Sharepoint"] = "08e18876-6177-487e-b8b5-cf950c1e598c";
    ClientAppId["ProjectReplicationService"] = "e62ee429-f250-4aef-a588-7b511fa9a67a";
    ClientAppId["CentroService"] = "00000006-0000-0ff1-ce00-000000000000";
    ClientAppId["ToDo"] = "5754bb84-f388-44f0-b3f7-9233a05bbb34";
    ClientAppId["ApprovalApp"] = "7c316234-ded0-4f95-8a83-8453d0876592";
    /** The "Olympus" (BCX MT) app used to acquire Copilot auth tokens */ ClientAppId["Olympus"] = "bb893c22-978d-4cd4-a6f7-bb6cc0d6e6ce";
    /** The "OfficeHome" (Office.com) app used to acquire the Copilot SSR token */ ClientAppId["OfficeHome"] = "4765445b-32c6-49b0-83e6-1d93765276ca";
    return ClientAppId;
}({});
/**
 * Constants for the client type to load planner
 */ export var ClientType = /*#__PURE__*/ function(ClientType) {
    ClientType["Teams"] = "Teams";
    ClientType["Web"] = "Web";
    ClientType["Sharepoint"] = "Sharepoint";
    ClientType["Loop"] = "Loop";
    ClientType["Dynamics"] = "Dynamics";
    ClientType["Outlook"] = "Outlook";
    ClientType["Office"] = "Office";
    return ClientType;
}({});
/**
 * Approved endpoint values for Copilot feedback attribution.
 */ export var CopilotFeedbackEndpoint = /*#__PURE__*/ function(CopilotFeedbackEndpoint) {
    CopilotFeedbackEndpoint["Microsoft365"] = "Microsoft 365";
    CopilotFeedbackEndpoint["Teams"] = "Teams";
    CopilotFeedbackEndpoint["Outlook"] = "Outlook";
    CopilotFeedbackEndpoint["Edge"] = "Edge";
    CopilotFeedbackEndpoint["Word"] = "Word";
    return CopilotFeedbackEndpoint;
}({});
export const CopilotFeedbackEndpointByClientType = {
    ["Teams"]: "Teams",
    ["Outlook"]: "Outlook",
    ["Office"]: "Microsoft 365",
    ["Web"]: "Edge"
};
/**
 * Application client flavors
 */ export var ClientFlavor = /*#__PURE__*/ function(ClientFlavor) {
    ClientFlavor["App"] = "App";
    ClientFlavor["Tab"] = "Tab";
    ClientFlavor["ConfigTab"] = "ConfigTab";
    ClientFlavor["RemoveTab"] = "RemoveTab";
    ClientFlavor["TaskFromMessage"] = "TaskFromMessage";
    ClientFlavor["Component"] = "Component";
    return ClientFlavor;
}({});
/**
 * Application surface types
 */ export var ClientSurface = /*#__PURE__*/ function(ClientSurface) {
    ClientSurface["Uno"] = "Uno";
    ClientSurface["Evo"] = "Evo";
    return ClientSurface;
}({});
/**
 * Environments supported in Uno
 */ export var Environment = /*#__PURE__*/ function(Environment) {
    Environment["Ppe"] = "Ppe";
    Environment["Prod"] = "Prod";
    Environment["Gcc"] = "Gcc";
    Environment["Gcch"] = "Gcch";
    Environment["Dod"] = "Dod";
    Environment["Agc"] = "Agc";
    /**
     * The french sovereign cloud
     */ Environment["Bleu"] = "Bleu";
    /**
     * The german sovereign cloud
     */ Environment["Delos"] = "Delos";
    return Environment;
}({});
/**
 * The AAD authority host for the french sovereign cloud
 */ export const BleuAuthorityHost = "https://login.sovcloud-identity.fr";
/**
 * The AAD authority host for the german sovereign cloud
 */ export const DelosAuthorityHost = "https://login.sovcloud-identity.de";
/**
 * Environment-specific Teams origins required for SDK initialization.
 * The SDK's built-in valid origins list may not include these hosts,
 * so they must be passed explicitly to app.initialize().
 * To add origins for other hosts (e.g., Outlook), add a new map and register it in hostOrigins.
 */ export const TeamsHostOrigins = {
    ["Bleu"]: [
        "https://teams.sovcloud.fr"
    ],
    ["Delos"]: [
        "https://teams.sovcloud.de"
    ]
};
/** Default commercial Teams host origin. */ export const DefaultTeamsHostOrigin = "https://teams.microsoft.com";
/** Environment-specific Teams root origins used when constructing Teams links. */ export const TeamsHostOriginByEnvironment = {
    ["Ppe"]: DefaultTeamsHostOrigin,
    ["Prod"]: DefaultTeamsHostOrigin,
    ["Gcc"]: DefaultTeamsHostOrigin,
    ["Gcch"]: "https://gov.teams.microsoft.us",
    ["Dod"]: "https://dod.teams.microsoft.us",
    ["Bleu"]: "https://teams.sovcloud.fr",
    ["Delos"]: "https://teams.sovcloud.de"
};
/** Maps each host client type to its environment-specific origins */ const hostOrigins = {
    ["Teams"]: TeamsHostOrigins
};
/**
 * Returns valid origins for SDK initialization based on host and environment.
 * Returns undefined for hosts/environments without custom origins,
 * which causes the SDK to use its built-in defaults.
 * @param clientType The host client type (Teams, Outlook, Office, etc.)
 * @param environment The current environment
 * @returns An array of valid origins or undefined to use SDK defaults.
 */ export function getValidOriginsForHost(clientType, environment) {
    return hostOrigins[clientType]?.[environment];
}
/**
 * Different tenant regions
 */ export var TenantRegion = /*#__PURE__*/ function(TenantRegion) {
    TenantRegion["Eu"] = "EU";
    TenantRegion["Row"] = "ROW";
    return TenantRegion;
}({});
/**
 * Constants shared with sharepoint webpart to define Plan Context association types
 */ export var SharePointAssociationType = /*#__PURE__*/ function(SharePointAssociationType) {
    SharePointAssociationType["SPWeb"] = "SPWeb";
    return SharePointAssociationType;
}({});
/**
 * Constants shared with Teams app used on plan context association types
 */ export var TeamsAppAssociationType = /*#__PURE__*/ function(TeamsAppAssociationType) {
    TeamsAppAssociationType["Board"] = "Board";
    return TeamsAppAssociationType;
}({});
/**
 * Constants shared with various apps for associationType on Plan Context/ContentLink
 */ export var AssociationType = /*#__PURE__*/ function(AssociationType) {
    AssociationType["SharePointSPWeb"] = "SPWeb";
    AssociationType["TeamsAppBoard"] = "Board";
    AssociationType["UnknownValue"] = "UnknownValue";
    return AssociationType;
}({});
/**
 * Enum of the different browsers
 */ export var Browser = /*#__PURE__*/ function(Browser) {
    Browser["Chrome"] = "Chrome";
    Browser["Edge"] = "Edge";
    Browser["Firefox"] = "Firefox";
    Browser["IE"] = "IE";
    Browser["Opera"] = "Opera";
    Browser["Other"] = "Other";
    Browser["Safari"] = "Safari";
    Browser["Electron"] = "Electron";
    return Browser;
}({});
/**
 * Constants related to users
 */ export const UnassignedUserId = "Unassigned";
/**
 * Enumeration of the possible user policy types for a user
 */ export var UserPolicyFlags = /*#__PURE__*/ function(UserPolicyFlags) {
    /**
     * No user policy
     */ UserPolicyFlags[UserPolicyFlags["None"] = 0] = "None";
    /**
     * User is not authorized to delete tasks that have not been created by the user
     */ UserPolicyFlags[UserPolicyFlags["CannotDeleteTasksNotCreatedBySelf"] = 1] = "CannotDeleteTasksNotCreatedBySelf";
    return UserPolicyFlags;
}({});
(function(RetryAjaxHelperConfigConstants) {
    RetryAjaxHelperConfigConstants.delayOnRetryInMiliseconds = 200;
    RetryAjaxHelperConfigConstants.maxRetryTimeoutInMiliseconds = 180000;
    RetryAjaxHelperConfigConstants.maxRetryCount = 2;
})(RetryAjaxHelperConfigConstants || (RetryAjaxHelperConfigConstants = {}));
/** Product id for Project used in Centro service*/ export const ProjectCentroProductId = "CFQ7TTC0HDB1";
/**
 * Constants for typing the plans used across the app
 */ export var PlanType = /*#__PURE__*/ function(PlanType) {
    PlanType["Basic"] = "Basic";
    PlanType["Premium"] = "Premium";
    PlanType["ToDo"] = "ToDo";
    PlanType["Unified"] = "Unified";
    return PlanType;
}({});
/**
 * Constants for persistent storage schema version
 */ export const persistentStorageSchemaVersion = "1";
/** Document ids with this prefix are stored in SharePoint */ export const SPDocIdPrefix = "SPO_";
/** MSA tenant Id */ export const MsaTenantId = "9188040d-6c67-4c5b-b112-36a304b66dad";
/** MSIT tenant id */ export const MicrosoftTenantId = "72f988bf-86f1-41af-91ab-2d7cd011db47";
/** Sharepoint site base domain for MSFT tenant for SDF*/ export const SPSiteBaseDomainForMSFTSDF = "microsoft.sharepoint-df.com";
/** Sharepoint site base domain for MSFT tenant*/ export const SPSiteBaseDomainForMSFT = "microsoft.sharepoint.com";
/** OneDrive Resource URI*/ export const OneDriveResourceUri = "pushchannel.1drv.ms";
export const TeamsChannelAgentContextScenarioId = "com.microsoft.teams.channel";
/**
 * A class with lists of supported cultures for different libraries the app uses e.g. Moment
 */ export class CultureConstants {
}
/**
     * List of ll-cc or just ll cultures that are rtl. Entries will be in the ll-cc format or ll format
     * https://lingohub.com/academy/best-practices/rtl-language-list
     */ CultureConstants.RtlCultures = [
    "ar",
    "he",
    "ur",
    "ku",
    "fa"
];
/**
     * A list of the currently supported cultures by the moment library
     */ CultureConstants.MomentCultures = [
    "ar",
    "ar-ly",
    "ar-ma",
    "ar-sa",
    "ar-tn",
    "bg",
    "ca",
    "cs",
    "cy",
    "da",
    "de",
    "de-at",
    "el",
    "en",
    "en-au",
    "en-ca",
    "en-gb",
    "en-ie",
    "en-in",
    "en-nz",
    "es",
    "es-do",
    "et",
    "eu",
    "fi",
    "fil",
    "fr",
    "fr-ca",
    "fr-ch",
    "gl",
    "he",
    "hi",
    "hr",
    "hu",
    "id",
    "is",
    "it",
    "ja",
    "ka",
    "kk",
    "ko",
    "lt",
    "lv",
    "ml",
    "ms-my",
    "nb",
    "nl",
    "nn",
    "no",
    "pl",
    "pt",
    "pt-br",
    "ro",
    "ru",
    "sr-cyrl",
    "sr",
    "sk",
    "sl",
    "sv",
    "th",
    "tr",
    "uk",
    "vi",
    "zh-cn",
    "zh-hk",
    "zh-tw"
];
// The default moment culture
CultureConstants.DefaultMomentCulture = "en";
/**
 * Class for learn more links
 */ export class LearnMoreLinks {
}
/** The learn more link for sensitivity labels */ LearnMoreLinks.sensitivityLabels = "https://go.microsoft.com/fwlink?linkid=2106748";
/** The learn more link for linked plans (PlanContexts) */ LearnMoreLinks.linkedPlans = "https://aka.ms/linkedplans";
/** The learn more link for Plans in Roster containers (lightweight plans) */ LearnMoreLinks.lightWeightPlans = "https://aka.ms/lightweightplans";
/** The learn more link for groups */ LearnMoreLinks.m365Groups = "https://go.microsoft.com/fwlink?linkid=2049051";
/** The learn more link for guest access */ LearnMoreLinks.guestAccess = "https://go.microsoft.com/fwlink?linkid=871797";
/** The learn more link for email and notifications */ LearnMoreLinks.emailAndNotifications = "https://go.microsoft.com/fwlink?linkid=866998";
/** The learn more link for copying and moving tasks in EVO*/ LearnMoreLinks.evoCopyAndMoveTasks = "https://go.microsoft.com/fwlink/?LinkId=2370881";
/** The learn more link for copying and moving tasks in UNO*/ LearnMoreLinks.unoCopyAndMoveTasks = "https://go.microsoft.com/fwlink?linkid=872349";
/** The learn more link for copying a plan */ LearnMoreLinks.copyPlan = "https://support.microsoft.com/en-us/office/copy-a-plan-50401e13-a25f-40df-93c6-b608cc28c3d4";
/** The learn more link for Try Project */ LearnMoreLinks.getStartedWithProjectForTheWeb = "https://support.microsoft.com/office/get-started-with-project-for-the-web-50bf3e29-0f0d-4b7a-9d2c-7c78389b67ad";
/** The learn more link for IE being deprecated :) */ LearnMoreLinks.ieDeprecated = "https://techcommunity.microsoft.com/t5/microsoft-365-blog/microsoft-365-apps-say-farewell-to-internet-explorer-11-and/ba-p/1591666";
/** The learn more link for shared plans */ LearnMoreLinks.sharedPlans = "https://go.microsoft.com/fwlink?linkid=2228058";
/** The learn more link for some fields like attachments being absent in personal task editor */ LearnMoreLinks.missingFields = "https://go.microsoft.com/fwlink/?linkid=2245039";
/** The learn more link for adding a forms requirement */ LearnMoreLinks.addFormsRequirement = "https://go.microsoft.com/fwlink/?linkid=2245040";
/** The learn more link for loop planner component */ LearnMoreLinks.usePlannerComponent = "https://go.microsoft.com/fwlink/?linkid=2245448";
/** The learn more link for Project/Premium plan P1 */ LearnMoreLinks.projectP1SubscriptionPlanLearnMoreUrl = "https://go.microsoft.com/fwlink/?linkid=2183548";
/** The learn more link for Project/Premium plan P3 */ LearnMoreLinks.projectP3SubscriptionPlanLearnMoreUrl = "https://go.microsoft.com/fwlink/?linkid=2183549";
/** The learn more link for Project/Premium plan P5 */ LearnMoreLinks.projectP5SubscriptionPlanLearnMoreUrl = "https://go.microsoft.com/fwlink/?linkid=2183649";
/** The learn more link for Project */ LearnMoreLinks.projectLearnMoreUrl = "https://go.microsoft.com/fwlink/?linkid=2261209";
/** The learn more link for importing plans */ LearnMoreLinks.importPlanLearnMoreUrl = "https://go.microsoft.com/fwlink/?linkid=2226056";
/** The planner(uno) help link */ LearnMoreLinks.plannerHelp = "https://go.microsoft.com/fwlink/?linkid=2260017";
/** The link to the license terms */ LearnMoreLinks.licenseTerms = "https://www.microsoft.com/servicesagreement";
/** The link to the privacy statement */ LearnMoreLinks.privacyStatement = "https://privacy.microsoft.com/privacystatement";
/** The link to how to join a group as a member */ LearnMoreLinks.joinGroupAsMember = "https://go.microsoft.com/fwlink/?linkid=2264502";
/** The terms of service link for in app trials */ LearnMoreLinks.trialTermsOfServiceUrl = "https://go.microsoft.com/fwlink?linkid=2204238";
/** The learn more link for attachments in plans that are not linked with M365 group */ LearnMoreLinks.attachmentsInNoM365GroupPlans = "https://support.microsoft.com/en-us/office/about-plans-that-aren-t-in-groups-3208332f-14db-408d-ba2a-58eea26b19d5";
/** The FRE learn more link */ LearnMoreLinks.fre = "https://go.microsoft.com/fwlink/?linkid=2283523";
/** The learn more link for sensitivity labels and Microsoft 365 Copilot */ LearnMoreLinks.sensitivityLabelsAndMicrosoft365Copilot = "https://learn.microsoft.com/en-us/purview/sensitivity-labels#sensitivity-labels-and-microsoft-365-copilot";
/** The learn more link for upgrading project operations version */ LearnMoreLinks.upgradeProjectOperationsVersion = "https://go.microsoft.com/fwlink/?linkid=2258148";
/** The learn more link for uno web redirect news banner */ LearnMoreLinks.ocdiRedirectNewsBanner = "https://go.microsoft.com/fwlink/?linkid=2280838";
/** The learn more link for PMA web grounding info */ LearnMoreLinks.webGroundingInfo = "https://learn.microsoft.com/en-us/copilot/microsoft-365/manage-public-web-access#it-admin-control-for-both-microsoft-365-copilot-and-microsoft-365-copilot-chat";
/** The list of supported languages for Microsoft 365 Copilot */ LearnMoreLinks.supportedLanguagesForCopilot = "https://support.microsoft.com/office/supported-languages-for-microsoft-365-copilot-94518d61-644b-4118-9492-617eea4801d8";
/** The learn more link for PMA in premium plans */ LearnMoreLinks.linkToLearnMoreAboutPma = "https://techcommunity.microsoft.com/blog/plannerblog/unleashing-the-power-of-agents-in-microsoft-planner/4304794";
/** The learn more link shown when a user attempts to create a portfolio without a required subscription. */ LearnMoreLinks.linkToLearnMoreAboutPortfolioSubscription = "https://www.microsoft.com/en-us/microsoft-365/planner/project-plan-3?activetab=pivot:overviewtab";
/** The link to your groups */ LearnMoreLinks.groups = "https://go.microsoft.com/fwlink/?linkid=2338373";
/** The learn more link for creating buckets to sort your tasks */ LearnMoreLinks.createBucket = "https://support.microsoft.com/en-us/office/create-buckets-to-sort-your-tasks-238af119-3c2b-4cbb-a124-29da99488139";
/** The learn more link for creating recurring tasks */ LearnMoreLinks.createRecurringTask = "https://support.microsoft.com/en-us/office/recurring-tasks-in-planner-9f2561ee-45ee-4834-955b-c457f8bb0490";
/** The learn more link for refreshing auth token */ LearnMoreLinks.refreshAuthTokenIE = "https://go.microsoft.com/fwlink/?linkid=851765";
/** The Microsoft Designer URL for AI-generated backgrounds */ LearnMoreLinks.microsoftDesigner = "https://designer.microsoft.com";
/** The planner blog link */ LearnMoreLinks.plannerBlog = "https://techcommunity.microsoft.com/category/planner/blog/plannerblog";
/** The learn more link for access denied due to sensitivity labels */ LearnMoreLinks.accessDeniedSensitivityLabel = "https://go.microsoft.com/fwlink/?linkid=2353649";
/** The learn more link for plan calendar settings */ LearnMoreLinks.planCalendarSettings = "https://go.microsoft.com/fwlink/?LinkId=2371049";
/** The learn more link for meeting plans expiration, deletion and recovery */ LearnMoreLinks.meetingPlansExpirationDeletionAndRecovery = "https://support.microsoft.com/planner/plans-from-meetings-expiration-deletion-recovery";
/**
 * Known teams app ids
 */ export var TeamsAppId = /*#__PURE__*/ function(TeamsAppId) {
    TeamsAppId["Dev"] = "3434be72-1bba-427b-83ca-43daf2ee0d22";
    TeamsAppId["PPE"] = "9c0fcd8d-7cca-466f-b549-9254dac9c036";
    TeamsAppId["Prod"] = "com.microsoft.teamspace.tab.planner";
    return TeamsAppId;
}({});
/**
 * Known outlook app ids
 */ export var OutlookAppId = /*#__PURE__*/ function(OutlookAppId) {
    OutlookAppId["PPE"] = "d7b99903-2600-4014-864d-4adc0a993af8";
    OutlookAppId["Prod"] = "75f31797-37c9-498e-8dc9-53c16a36afca";
    return OutlookAppId;
}({});
/**
 * Enum for various PageIds based on Teams UNO App Flavor - note that other scenarios (eg tab) will have different PageIds
 * A PageId (formerly known as EntityId) identifies the page showing the content
 */ export var AppPageIdFlavor = /*#__PURE__*/ function(AppPageIdFlavor) {
    AppPageIdFlavor["Dev"] = "teamstasksdev.personalApp.mytasks";
    AppPageIdFlavor["PPE"] = "teamstasksppe.personalApp.mytasks";
    AppPageIdFlavor["Prod"] = "mytasks";
    return AppPageIdFlavor;
}({});
/** Bucket id prefix used for copying / moving into uncategorized bucket */ export const UncategorizedBucketId = "UNCATEGORIZED";
/** The path for the unified group info page in outlook web */ export const outlookUnifiedGroupPath = "/owa/?path=/group/{0}/people";
/** A mapping of all supported environments to the rollout stages allowed to exist in the respective environments. */ export const allowedRolloutStagesForEnvironment = new Map([
    [
        "Agc",
        [
            RolloutStage.AirGap
        ]
    ],
    [
        "Dod",
        [
            RolloutStage.DoD
        ]
    ],
    [
        "Gcc",
        [
            RolloutStage.Gcc
        ]
    ],
    [
        "Gcch",
        [
            RolloutStage.Gcch
        ]
    ],
    [
        "Ppe",
        [
            RolloutStage.PreProd
        ]
    ],
    [
        "Prod",
        [
            RolloutStage.Demo,
            RolloutStage.Dev,
            RolloutStage.DogfoodDev,
            RolloutStage.DogfoodStaging,
            RolloutStage.DogfoodAll,
            RolloutStage.ProdMSIT,
            RolloutStage.ProdBetaTAP,
            RolloutStage.ProdAll
        ]
    ]
]);
export const AppRootElementId = "root";
(function(OfficeBrowserFeedbackConstants) {
    OfficeBrowserFeedbackConstants.AppId = 2204;
})(OfficeBrowserFeedbackConstants || (OfficeBrowserFeedbackConstants = {}));
(function(Attachment) {
    Attachment.DisplayNameMaxLength = 100;
    Attachment.UrlMaxLength = 2000;
})(Attachment || (Attachment = {}));
(function(Task) {
    Task.TitleMaxLength = 100;
})(Task || (Task = {}));
export var RetryAjaxHelperConfigConstants, OfficeBrowserFeedbackConstants, Attachment, Task;
